exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clickable-18d1a46b{cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"clickable": "clickable-18d1a46b"
};